import React from "react";
import { Spinner } from "reactstrap";

const CardLoader = ({ title = "" }) => {
  return (
    <div className="d-flex justify-content-center">
      <div className="m-5 text-center">
        <p>{title}</p>
        <Spinner className="" color="primary">
          Loading...
        </Spinner>
      </div>
    </div>
  );
};

export default CardLoader;
